var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.16146 8.4349C7.16146 9.17128 7.75841 9.76823 8.49479 9.76823C9.23117 9.76823 9.82812 9.17128 9.82812 8.4349C9.82812 7.69852 9.23117 7.10156 8.49479 7.10156C7.75841 7.10156 7.16146 7.69852 7.16146 8.4349Z",
    fill: "#272B30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1667 8.43328C11.1667 7.67063 10.9114 6.96952 10.4812 6.40811C10.2573 6.11585 10.3126 5.69739 10.6049 5.47345C10.8972 5.24952 11.3156 5.30491 11.5396 5.59717C12.1418 6.38315 12.5 7.36733 12.5 8.43328C12.5 9.54424 12.111 10.5661 11.4622 11.3676C11.2306 11.6537 10.8108 11.6979 10.5246 11.4663C10.2384 11.2346 10.1942 10.8149 10.4259 10.5287C10.8895 9.95597 11.1667 9.2279 11.1667 8.43328Z",
    fill: "#272B30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83333 8.43593C5.83333 7.67229 6.08931 6.97033 6.5205 6.40855C6.74468 6.11647 6.68964 5.69797 6.39756 5.47379C6.10549 5.24961 5.68698 5.30465 5.4628 5.59673C4.85914 6.38322 4.5 7.36858 4.5 8.43593C4.5 9.54603 4.88845 10.5672 5.53625 11.3684C5.76776 11.6547 6.18752 11.6991 6.47382 11.4676C6.76013 11.2361 6.80455 10.8163 6.57304 10.53C6.11012 9.9575 5.83333 9.22994 5.83333 8.43593Z",
    fill: "#272B30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8385 8.43028C13.8385 6.94225 13.2977 5.58223 12.4011 4.5335C12.1618 4.25365 12.1947 3.83283 12.4745 3.59356C12.7544 3.3543 13.1752 3.38719 13.4145 3.66704C14.5098 4.94812 15.1719 6.61273 15.1719 8.43028C15.1719 10.2896 14.479 11.9888 13.3384 13.2811C13.0947 13.5572 12.6734 13.5835 12.3974 13.3398C12.1213 13.0962 12.0951 12.6749 12.3387 12.3988C13.2726 11.3407 13.8385 9.9524 13.8385 8.43028Z",
    fill: "#272B30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.16146 8.43005C3.16146 6.94212 3.70222 5.58218 4.59876 4.53348C4.83801 4.25362 4.80509 3.8328 4.52523 3.59354C4.24538 3.35429 3.82455 3.38721 3.5853 3.66707C2.49012 4.94811 1.82813 6.61262 1.82813 8.43005C1.82813 10.2869 2.51912 11.984 3.65703 13.2757C3.90041 13.552 4.32167 13.5786 4.59795 13.3353C4.87423 13.0919 4.90089 12.6706 4.65751 12.3943C3.72586 11.3368 3.16146 9.95013 3.16146 8.43005Z",
    fill: "#272B30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/live.1f02fe3bbd1b8ebb080ef461015455a0.svg";
export { ForwardRef as ReactComponent };